import _extends from "@babel/runtime-corejs3/helpers/extends";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import { createElementVNode as _$ce, createUnknownComponentVNode as _$cc, noop as _$no, className as _$cn, createVNode as _$cv } from 'intact-vue-next';
import { getRestProps, mapChildren } from '../utils';
import { BreadcrumbItem } from './item';
import { makeStyles } from './styles';
import { Icon } from '../icon';
var _$tmp0 = {
  'className': 'k-icon-right'
};
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _$blocks = {};
  var __$blocks = {};
  var _this$get = this.get(),
    children = _this$get.children,
    separator = _this$get.separator,
    className = _this$get.className;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-breadcrumb"] = true, _classNameObj[className] = className, _classNameObj[makeStyles(k)] = true, _classNameObj);
  var separatorVNode = _$ce(2, 'span', !$blocks.separator && !separator ? _$cc(Icon, _$tmp0) : (_$blocks['separator'] = function ($super) {
    return separator;
  }, __$blocks['separator'] = function ($super, data) {
    var block = $blocks['separator'];
    var callBlock = function callBlock() {
      return _$blocks['separator'].call($this, $super, data);
    };
    return block ? block.call($this, callBlock, data) : callBlock();
  }, __$blocks['separator'](_$no)), 0, _$cn(k + "-breadcrumb-separator"));
  var vNodes = [];
  var lastIndex = -1;
  var separatorAmount = 0;
  mapChildren(children, function (vNode, index) {
    vNodes.push(vNode);
    if (vNode.tag === BreadcrumbItem) {
      lastIndex = index;
      separatorAmount++;
      vNodes.push(separatorVNode);
    }
  });
  // remove the last BreadcrumbItem's separator,
  // because it may have other vNodes follow the last BreadcrumbItem.
  // we record the last separator's index and splice array like bellow to remove it
  if (lastIndex > -1) {
    _spliceInstanceProperty(vNodes).call(vNodes, lastIndex + separatorAmount, 1);
  }
  return _$cv('div', _extends({
    'className': _$cn(classNameObj)
  }, getRestProps(this)), vNodes);
}
;